import { camelCaseFixProject, ICamelCaseFixProject } from "./camelCaseFix";

export interface IProjectCleaner extends ICamelCaseFixProject {
  projectFocus: string[];
  /** @deprecated */
  project_Focus?: string;
}

export const projectCleaner = (project: IProjectCleaner): IProjectCleaner => {
  // This is added because the Project Focus field was created with an underscore
  // Code has been added to prevent field names with underscores as part of this story
  // https://dev.azure.com/MilwaukeeToolAppDev/Moon%20Men/_workitems/edit/40846
  project.projectFocus = project.projectFocus || project.project_Focus || [];
  delete project.project_Focus;

  project = camelCaseFixProject(project);

  return project;
};
